import { render, staticRenderFns } from "./PosteAimPicker.vue?vue&type=template&id=47ca6fb0"
import script from "./PosteAimPicker.vue?vue&type=script&setup=true&lang=js"
export * from "./PosteAimPicker.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports